
import firebase from 'firebase/app';
import { IS_PRODUCTION } from '../firebase/firebase';

const firebaseLogEvent = firebase.analytics().logEvent;

enum LogLevels {
  Trace,
  Debug,
  Info,
  Warn,
  Error,
  Fatal,
}

const LOCAL_LOG_LEVEL = LogLevels.Info;

export const LOG_EVENT = (...args: Parameters<typeof firebaseLogEvent>) => {
  console.log(IS_PRODUCTION);
  if (IS_PRODUCTION) {
    return firebase.analytics().logEvent(...args);
  } else {
    console.log(LOCAL_LOG_LEVEL <= LogLevels.Info);
    console.log(LOCAL_LOG_LEVEL, LogLevels.Info);
    if (LOCAL_LOG_LEVEL <= LogLevels.Info) {
      console.log(...args);
    }
  }
};

export const LOG_ERROR = (...args: Parameters<typeof firebaseLogEvent>) => {
  if (IS_PRODUCTION) {
    return firebase.analytics().logEvent(...args);
  } else {
    if (LOCAL_LOG_LEVEL <= LogLevels.Error) {
      console.error(...args);
    }
  }
};
